import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=b4c175ac&scoped=true"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=b4c175ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c175ac",
  null
  
)

export default component.exports